module.exports = __webpack_public_path__ + "img/redshift.6d692e99.svg";